/**
 * Utility functions for determining admin context
 */

/**
 * Check if the current route is an admin management route
 * Supports both legacy (/user/admin) and new (/settings/admins) routes
 */
export const isAdminManagementRoute = (currentRoute?: string): boolean => {
  if (!currentRoute) return false;
  return currentRoute.startsWith('/user/admin') || currentRoute.startsWith('/settings/admins');
};

/**
 * Check if the current route is under the settings admins path (/settings/admins)
 * This is a narrower helper used by navigation components that only care about
 * the settings admins section (not legacy /user/admin routes).
 */
export const isAdminsRoute = (currentRoute?: string): boolean => {
  if (!currentRoute) return false;
  // Match '/settings/admins' anywhere in the path to account for activeSite prefixes
  return currentRoute.includes('/settings/admins');
};

// Standard user edit path and helper
export const USER_EDIT_PATH = '/user/edit';
export const isUserEditRoute = (currentRoute?: string): boolean => {
  if (!currentRoute) return false;
  return currentRoute.includes(USER_EDIT_PATH);
};

/**
 * Get the admin list search path based on context
 * Returns /user/admin/search or /settings/admins/manage depending on where we are
 */
export const getAdminSearchPath = (currentRoute?: string): string => {
  if (!currentRoute) return '/user/admin/search';
  return currentRoute.startsWith('/settings/admins') ? '/settings/admins/manage' : '/user/admin/search';
};

// Centralized admin edit route constants and helpers
export const ADMIN_EDIT_PATH = '/settings/admins/edit';
export const ADMIN_GROUPS_EDIT_PATH = '/settings/admins/groups/edit';

export const isAdminEditRoute = (currentRoute?: string): boolean => {
  if (!currentRoute) return false;
  return currentRoute.includes(ADMIN_EDIT_PATH);
};

export const isAdminGroupsEditRoute = (currentRoute?: string): boolean => {
  if (!currentRoute) return false;
  return currentRoute.includes(ADMIN_GROUPS_EDIT_PATH);
};
